import { Device } from '../helpers'
import { getQueryParam } from '../helpers/getQueryParam'
import * as loadjs from 'loadjs'

const loglevel = getQueryParam('loglevel', window.location.search)
export const IMA_CDN =
  loglevel === 'debug'
    ? 'https://imasdk.googleapis.com/js/sdkloader/ima3_debug.js'
    : 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'

export class IMAFacade {
  static onReady<T>(cb: Function): Promise<T> {
    if (window.google && window.google.ima) {
      return Promise.resolve(cb())
    }

    // Anything returned by these cb's will be resolved after GPT is ready
    return new Promise((resolve) => {
      loadjs(IMA_CDN, () => {
        resolve(cb())
      })
    }).then((result) => result as T)
  }

  static async getDisplayContainer(
    container: HTMLElement
  ): Promise<google.ima.AdDisplayContainer> {
    return IMAFacade.onReady<google.ima.AdDisplayContainer>(() => {
      const adDisplayContainer = new window.google.ima.AdDisplayContainer(
        container
      )
      adDisplayContainer.initialize()
      return adDisplayContainer
    })
  }
  static async getAdsLoader(
    container: google.ima.AdDisplayContainer
  ): Promise<google.ima.AdsLoader> {
    return IMAFacade.onReady<google.ima.AdsLoader>(() => {
      const adsLoader = new window.google.ima.AdsLoader(container)
      return adsLoader
    })
  }
  static async enableVPAID(): Promise<void> {
    return IMAFacade.onReady<void>(() => {
      const vpaidMode = window.google.ima.ImaSdkSettings.VpaidMode.ENABLED
      window.google.ima.settings.setVpaidMode(vpaidMode)
      window.google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true)
    })
  }

  static async getAdsRequest({
    vastXml,
    vastUrl,
    height,
    width,
    autoplay,
    muted
  }: IVideoAdConfig): Promise<google.ima.AdsRequest> {
    return IMAFacade.onReady<google.ima.AdsRequest>(() => {
      const adsRequest = new window.google.ima.AdsRequest()
      /**  Sometimes 'ad' doesn't exist, so fallback to vastXml */
      adsRequest.adsResponse = vastXml
      /**  IndexExchange only returns `vastUrl` */
      if (!adsRequest.adsResponse && vastUrl) {
        adsRequest.adTagUrl = vastUrl
      }
      /**
       * Specify the linear and nonlinear slot sizes. This helps the SDK to
       * select the correct creative if multiple are returned.
       */
      adsRequest.linearAdSlotWidth = width
      adsRequest.linearAdSlotHeight = height
      adsRequest.nonLinearAdSlotWidth = width
      adsRequest.nonLinearAdSlotHeight = height
      adsRequest.setAdWillAutoPlay(autoplay)
      adsRequest.setAdWillPlayMuted(muted)
      return adsRequest
    })
  }
}
export interface IVideoAdConfig {
  vastXml?: string
  vastUrl?: string
  height: number
  width: number
  autoplay: boolean
  muted: boolean
}
